module.exports = __webpack_public_path__ + "static/media/todoapp-pic-R.a3e6770f.PNG";